import datadownloadApis from "./user/course/datadownload";
import selectivecourseApis from "./user/course/selectivecourse";
import todolistApis from "./user/course/todolist";
import noticeApis from "./user/course/notice";
import homeApis from "./user/course/home";
import teacherHomeApis from "./teacher/home";
import loginApis from "./user/login";
import confirmIdentityApis from "./confirmIdentity";
import ossApis from "./ossApis";
export {
  datadownloadApis,
  selectivecourseApis,
  todolistApis,
  noticeApis,
  homeApis,
  loginApis,
  teacherHomeApis,
  confirmIdentityApis,
  ossApis
};



// WEBPACK FOOTER //
// ./src/api/index.js